module.exports = __webpack_public_path__ + "static/dl1-banner3-3727e3fe9915a9ed22f7a7414e4e513c.jpg";